import React from "react";
import { EXPERIENCE } from "@/data/portfolio";

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="bg-background"
    >
      <div className="max-w-3xl mx-auto px-6 py-10">
        <hr className="rule" />
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-6">
          Experience
        </h2>

        {EXPERIENCE.map((exp) => (
          <article
            key={exp.company}
            data-testid={`experience-${exp.company.toLowerCase()}`}
            className="mb-10"
          >
            <header className="mb-4">
              <h3 className="font-serif text-xl md:text-2xl text-foreground">
                {exp.role},{" "}
                <span className="italic">{exp.company}</span>
              </h3>
              <p className="text-sm text-quiet mt-1">
                {exp.period} &middot; {exp.location}
              </p>
            </header>

            <ul className="space-y-3 pl-5 list-disc marker:text-quiet">
              {exp.highlights.map((h, j) => (
                <li
                  key={j}
                  className="text-base text-foreground/85 leading-relaxed"
                >
                  {h}
                </li>
              ))}
            </ul>

            <p className="mt-5 text-sm text-quiet">
              <span className="small-caps">Stack:</span>{" "}
              {exp.stack.join(" · ")}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};
